import { NvMenu } from '@simwood/nv-react-components';
import React, { useMemo } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { setVisibleExtensionMenu } from '../../reducers/client';
import { StoreState } from '../../store';
import { ExtensionStatus } from '../../types/SipExtension';
import * as styles from './styles.module.scss';

export interface Props {
  extensionStatus?: ExtensionStatus;
  dnd?: boolean;
  onDndChange?: (dnd: boolean) => void;
}

const statusMap: Record<ExtensionStatus, string> = {
  disconnected: styles.disconnected,
  registering: styles.registering,
  registered: styles.registered,
  registrationFailed: styles.registrationFailed,
};

const ExtensionPill: React.FC<Props> = ({
  extensionStatus,
  dnd,
  onDndChange,
}) => {
  const dispatch = useDispatch();
  const extensionName = useSelector(
    (state: StoreState) => state.client.extension?.name || '',
  );
  const extensionShortNumber = useSelector(
    (state: StoreState) => state.client.extension?.shortNumber || '',
  );
  const menuItems = useMemo(
    () => [
      ...(onDndChange
        ? [
            {
              label: dnd ? 'Turn Off Do Not Disturb' : 'Turn On Do Not Disturb',
              onClick: () => onDndChange(!dnd),
            },
          ]
        : []),
      {
        label: 'Extension Settings',
        onClick: () => {
          dispatch(setVisibleExtensionMenu('extension'));
        },
      },
      {
        label: 'Voicemail Settings',
        onClick: () => {
          dispatch(setVisibleExtensionMenu('voicemail'));
        },
      },
      {
        label: 'Forwarding Rules',
        onClick: () => {
          dispatch(setVisibleExtensionMenu('forwardingRules'));
        },
      },
    ],
    [dispatch, dnd, onDndChange],
  );

  const trigger = useMemo(
    () => (
      <div className={styles.button}>
        {extensionStatus && (
          <span
            className={[styles.indicator, statusMap[extensionStatus]].join(' ')}
          />
        )}
        <span>
          {extensionShortNumber} {extensionName}
        </span>
        {dnd && (
          <span className={styles.dnd} title='Do Not Disturb is on'>
            DND
          </span>
        )}
      </div>
    ),
    [dnd, extensionName, extensionShortNumber, extensionStatus],
  );
  return <NvMenu icon={trigger} data={menuItems} />;
};

export default ExtensionPill;
